import unhead_KgADcZ0jPj from "/var/www/jomar-manalo-portfolio/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/jomar-manalo-portfolio/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import revive_payload_server_eJ33V7gbc6 from "/var/www/jomar-manalo-portfolio/node_modules/nuxt/dist/app/plugins/revive-payload.server.js";
import components_plugin_KR1HBZs4kY from "/var/www/jomar-manalo-portfolio/.nuxt/components.plugin.mjs";
export default [
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  revive_payload_server_eJ33V7gbc6,
  components_plugin_KR1HBZs4kY
]